/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface ZocdocProviderReviews {
  provider_id: string;
  total_reviews: number;
  average_overall_rating?: number | null;
}
